import { render, staticRenderFns } from "./NoticeWrapper.vue?vue&type=template&id=a814d5aa&"
import script from "./NoticeWrapper.vue?vue&type=script&lang=js&"
export * from "./NoticeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NoticeWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports